import type { EventListFilters } from '../../useEventListFilters';

export const GEOLOCATION_FIELDS = [
  'cities', 'areas', 'districts', 'streets', 'house_numbers',
  'origin_longitude', 'longitude_delta', 'origin_latitude', 'latitude_delta',
] satisfies (keyof EventListFilters)[];

export const hasLocationFilters = (filters: EventListFilters): boolean => (
  GEOLOCATION_FIELDS.some((field) => filters[field] !== undefined)
);
